import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/header";
import Layout from "../../components/layout";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import Icon from "../../components/icons";
import Drawer from "../../components/Drawer";
import { Dropdown, Menu } from "../../components/Dropdown";
import Button from "../../components/elements/button";
import { useFacilitiesApi } from "../../store/api/hooks/facilitiesApiHook";
import toast from "react-hot-toast";
import { useDialog } from "../../store/api/hooks/dialogHook";
import moment from "moment";
import { PAGE_SIZE, schedulerFrequecyEnum } from "../../_common/constant";
import Pagination from "../../components/pagination";
import Search from "../../components/search";
import { getPermissionInfo, showLocalDate } from "../../_common/functions";
import Loader from "../../components/loader";
import Filters from "../../components/filters";
import { filterConfigType } from "../../_config/types";
import { titleCell } from "../../components/elements/function";
import CreateScheduler from "./_components/createScheduler";
import { useWorkOrderApi } from "../../store/api/hooks/workOrderApiHook";
import CalendarMP from "./_components/calendarMP";
import { useWorkRequestApi } from "../../store/api/hooks/workRequestApiHook";
import { useMaintenanceCalendarApi } from "../../store/api/hooks/maintenanceCalendarApiHook";
import OpenWOlistModal from "../Assets/_components/Maintenance/openWOlist.modal";
import { set } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { useUserSelector } from "../../store/selectors/userSelector";
ModuleRegistry.registerModules([AllCommunityModule]);

const MaintenanceCalendar: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchParam, setSearchParam] = useState<string>("");
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [facilityoption, setFacilityoption] = useState<any>([]);
  const [priorityoption, setPriorityoption] = useState<any>([]);
  const [statusoption, setStatusoption] = useState<any>([]);
  const [assigntypeoption, setAssigntypeoption] = useState<any>([]);
  const [rowData, setRowData] = useState<any>(null);
  const [gridApi, setGridApi] = useState<any>(null);
  //   const [gridColumnApi, setGridColumnApi] = useState<any>(null);
  const [editData, setEditData] = useState<any>(null);
  const [duplicateFrom, setDuplicateFrom] = useState<any>(null);
  const [view, setView] = useState<"list" | "calendar">("list");
  const [filters, setFilters] = useState<any>({});
  const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false, locationFilter: false });
  const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);

  // Load filters from localStorage on component mount
  useEffect(() => {
    const savedFilters = localStorage.getItem('maintenanceCalendarFilters');
    if (savedFilters) {
      try {
        const parsedFilters = JSON.parse(savedFilters);
        setFilters(parsedFilters);
      } catch (error) {
        console.error('Error parsing saved filters:', error);
        setFilters({});
      }
    } else {
      setFilters({});
    }
    setFiltersInitialized(true);
  }, []);

  // Save filters to localStorage when filters change
  useEffect(() => {
    if (Object.keys(filters).length > 0) {
      localStorage.setItem('maintenanceCalendarFilters', JSON.stringify(filters));
    }
  }, [filters]);

  const woListModelRef = useRef<HTMLDialogElement>(null);
  const createDrawerRef: any = useRef();
  const filtersRef: any = useRef();
  const createSchedulerRef: any = useRef();
  const location = useLocation();
  const loggedinuser: any = useUserSelector();

  const filterConfig: filterConfigType[] = [
    { name: "Schdule No", type: "text", key: "schedulerCode" },
    // {
    //   name: "Facility",
    //   type: "dropdown",
    //   key: "facilityIDs",
    //   options: facilityoption ? facilityoption : [],
    // },
    {
      name: "Priority",
      type: "dropdown",
      key: "priorityIDs",
      options: priorityoption ? priorityoption : [],
    },
    {
      name: "Status",
      type: "dropdown",
      key: "statusIDs",
      options: statusoption ? statusoption : [],
    },
    {
      name: "Assign Type",
      type: "dropdown",
      key: "assignmentTypeIDs",
      options: assigntypeoption ? assigntypeoption : [],
    },
    // { name: 'Work Request ID', type: 'text', key: 'workRequestID' },
    { name: "Planned Start Date", type: "date", key: "planStartDate" },
    { name: "Planned End Date", type: "date", key: "planEndDate" },
  ];

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      width: 50,
      headerClass: "bg-[#f0f0f0]",
    },
    {
      headerName: "Schedule No",
      field: "schedulerCode",
      headerClass: "bg-[#f0f0f0]",
      minWidth: 190,
      flex: 1,
      cellRenderer: (param: any) => {
        return (
          <p className="hover:text-primary font-semibold cursor-pointer">
            {param.value}
          </p>
        );
      },
      onCellClicked: (param: any) => {
        openModalWithScheduler(param.data);
      },
      tooltipValueGetter: (params: any) => {
        return params.data;
      },
    },

    {
      headerName: "Scheduler Type",
      field: "every",
      headerClass: "bg-[#f0f0f0]",
      width: 160,
      cellRenderer: (param: any) => {
        const frequencyLabel = schedulerFrequecyEnum[
          param?.data?.frequencyName as keyof typeof schedulerFrequecyEnum
        ] || param?.data?.frequencyName || "";
        return (
          <p>
            {`Every ${param.data?.every} ${frequencyLabel}(s)`}
          </p>
        );
      },
    },
    {
      headerName: "Priority",
      field: "priorityName",
      headerClass: "bg-[#f0f0f0]",
      width: 150,
      flex: 1,
      cellRenderer: titleCell,
    },
    {
      headerName: "Task Description",
      field: "woDescription",
      headerClass: "bg-[#f0f0f0]",
      width: 150,
      flex: 1,
      cellRenderer: titleCell,
    },
    {
      headerName: "Facility",
      field: "facilityName",
      headerClass: "bg-[#f0f0f0]",
      minWidth: 160,
      cellRenderer: (params: any) => {
        return <p className="">{params.data.facilityName}</p>;
      },
      tooltipValueGetter: (params: any) => {
        return (
          params.data.facilityName +
          (params.data.subFacilityName
            ? `, ${params.data.subFacilityName}`
            : "")
        );
      },
    },
    {
      headerName: "Start Date",
      field: "planStartDate",
      headerClass: "bg-[#f0f0f0]",
      width: 140,
      cellStyle: { textAlign: "center" },
      cellRenderer: (data: any) => {
        return (
          <p className="">{data.value ? showLocalDate(data.value) : `--`}</p>
        );
      },
      // onCellClicked: (param: any) => {
      //     navigate(URLS.WORK_ORDER_DETAILS(param.data.workOrderID));
      // },
      tooltipValueGetter: (params: any) => {
        return +params.data.statusID >= 4
          ? //Actual start datetime
          params.data.originalPlanStartDate
            ? moment
              .utc(params.data.originalPlanStartDate)
              .local()
              .format(`MM/DD/YYYY hh:mm A`)
            : ""
          : params.data.planStartDate
            ? moment
              .utc(params.data.planStartDate)
              .local()
              .format(`MM/DD/YYYY hh:mm A`)
            : `--`;
      },
    },
    {
      headerName: "End Date",
      field: "planEndDate",
      headerClass: "bg-[#f0f0f0]",
      width: 140,
      cellRenderer: (data: any) => {
        return (
          <p className="">{data.value ? showLocalDate(data.value) : `--`}</p>
        );
      },
      // onCellClicked: (param: any) => {
      //     navigate(URLS.WORK_ORDER_DETAILS(param.data.workOrderID));
      // },
      tooltipValueGetter: (params: any) => {
        return +params.data.statusID >= 4
          ? //Actual start datetime
          params.data.originalPlanEndDate
            ? moment
              .utc(params.data.originalPlanEndDate)
              .local()
              .format(`MM/DD/YYYY hh:mm A`)
            : ``
          : params.data.planEndDate
            ? moment
              .utc(params.data.planEndDate)
              .local()
              .format(`MM/DD/YYYY hh:mm A`)
            : `--`;
      },
    },
    {
      headerName: "Added Date",
      field: "addedDate",
      headerClass: "bg-[#f0f0f0]",
      width: 160,
      cellRenderer: (params: any) => {
        return (
          <p className="">
            {params?.value
              ? moment.utc(params?.value).local().format(`MM/DD/YY`) +
              " | " +
              moment.utc(params?.value).local().format(`hh:mm`)
              : `--`}
          </p>
        );
      },
    },
    {
      headerName: "Added By",
      field: "addedByName",
      headerClass: "bg-[#f0f0f0]",
      width: 150,
      cellRenderer: titleCell,
    },
    {
      headerName: "Action",
      field: "action",
      headerClass: "bg-[#f0f0f0] text-center",
      pinned: 'right',
      width: 90,
      cellRenderer: (params: any) => {
        return (
          <div className="relative h-full w-full flex items-center justify-center">
            <Icon
              name="threedote"
              size={1.25}
              className="text-[#000000]"
              onClick={(e: any) => {
                e.stopPropagation();
                e.preventDefault();
                const dropdown: any =
                  document.querySelector(".action-dropdown");
                if (dropdown) {
                  dropdown.focus();
                }
                return false;
              }}
            />
            <select
              onChange={(e) => {
                const action = e.target.value;

                if (!getPermissionInfo(location.pathname, action, loggedinuser)) {
                  toast.error(`You don't have ${action} permission`);
                  e.target.selectedIndex = -1;
                  return;
                }

                handleActionChange(e, params);
                e.target.selectedIndex = -1;
              }}
              onFocus={(e) => {
                e.target.selectedIndex = -1;
              }}
              className="action-dropdown"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                opacity: 0,
                cursor: "pointer",
              }}
            >
              {(() => {
                // const isFutureDate = moment(params.data.planStartDate).isAfter(moment());
                return (
                  <>
                    <option value="edit" disabled={!getPermissionInfo(location.pathname, "edit", loggedinuser)}>Edit</option>
                    <option value="delete" disabled={!getPermissionInfo(location.pathname, "delete", loggedinuser)}>Delete</option>
                    <option value="duplicate" disabled={!getPermissionInfo(location.pathname, "Duplicate", loggedinuser)}>Duplicate</option>
                    {/* {isFutureDate && <option value="delete">Delete</option>} */}
                  </>
                );
              })()}
            </select>
          </div>
        );
      },
    },
  ];

  const facilityApi: any = useFacilitiesApi();
  const workOrderApi: any = useWorkOrderApi();
  const workRequestAPI: any = useWorkRequestApi();
  const maintenanceCalendarApi = useMaintenanceCalendarApi();

  const { confirm } = useDialog();

  const handleActionChange = (e: any, params: any) => {
    const action = e.target.value;
    const rowData = params.data;

    // Check permission before performing any action
    if (!getPermissionInfo(location.pathname, action, loggedinuser)) {
      toast.error(`You don't have ${action} permission`);
      e.target.selectedIndex = -1;
      return;
    }

    switch (action) {
      case "edit":
        // Implement edit action
        setEditData(rowData);
        createDrawerRef.current.open();
        console.log("Edit action for row: ", rowData);
        break;
      case "delete":
        // Implement delete action
        confirm({
          type: "delete",
          title: "Delete Facility",
          message: "Are you sure you want to delete this Task?",
          onConfirm: () => {
            const payload = { schedulerID: rowData.schedulerID };
            // workOrderApi.DeleteWorkOrder(payload, (resp: any, msg: any) => {
            maintenanceCalendarApi.deleteScheduler(
              payload,
              (resp: any, msg: any) => {
                toast.success(msg);
                getSchedulerList();
              },
              (error: any) => {
                console.log("error =>", error);
                toast.error(error);
              }
            );
          },
        });

        break;
      case "duplicate":
        maintenanceCalendarApi.getSchedulerByID(
          { SchedulerID: rowData.schedulerID },
          (resp: any) => {
            setDuplicateFrom(resp);
            createDrawerRef.current.open();
          },
          (error: any) => {
            toast.error(error);
          }
        );
        break;
      default:
        console.log("Unknown action: ", action);
    }
    e.target.selectedIndex = -1;
  };

  const onGridReady = (params: any) => {
    setGridApi(params.api);
    // setGridColumnApi(params.columnApi);
  };

  const onRowClicked = (event: any) => {
    if (!event.event.target.closest('input[type="checkbox"]')) {
      event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
    }
  };

  const getSchedulerList = () => {
    const payload: any = {
      pageSize: PAGE_SIZE,
      pageNumber: currentPage,
      searchParam: searchParam,
    };

    if (filters) {
      Object.keys(filters).map((key: any) => {
        if (filters[key]) {
          if (key === `planStartDate` || key === `planEndDate`) {
            payload[key] = moment(filters[key]).format(`YYYY-MM-DD`); // Format date to YYYY-MM-DD
          } else {
            payload[key] = filters[key];
          }
        }
      });
    }
    setRowData(null);
    maintenanceCalendarApi.getSchedulerList(
      payload,
      (resp: any, message: string) => {
        setRowData(resp?.schedulerList ? resp?.schedulerList : []);
        setTotalRecords(resp.totalRecord);
      },
      (error: any) => {
        console.log("error =>", error);
        toast.error(error);
      }
    );
  };

  const init_page_data = async () => {
    // Fetch facility list
    const facilityapiresp = await new Promise((resolve, reject) => {
      facilityApi.getFacilityList(
        {},
        (resp: any) => {
          let facilitylist: any = [];
          resp.facilityList.map((facilist: any) => {
            facilitylist.push({
              label: facilist.facilityName,
              value: facilist.facilityID,
              data: facilist,
            });
          });
          resolve(facilitylist);
        },
        (error: any) => {
          console.log("error =>", error);
          toast.error(error);
          reject(error);
        }
      );
    }).catch((error: any) => []);
    setFacilityoption(facilityapiresp);

    // Fetch priority list
    const priorityapiresp = await new Promise((resolve, reject) => {
      workRequestAPI.GetPriorityList(
        {},
        (resp: any) => {
          let prioritylist: any = [];
          resp.workRequestPriorityList.map((facilist: any) => {
            prioritylist.push({
              label: facilist.workRequestPriorityName,
              value: facilist.workRequestPriorityID,
              data: facilist,
            });
          });
          resolve(prioritylist);
        },
        (error: any) => {
          console.log("error =>", error);
          toast.error(error);
          reject(error);
        }
      );
    }).catch((error: any) => []);
    setPriorityoption(priorityapiresp);

    // Fetch status list
    const statusapiresp = await new Promise((resolve, reject) => {
      workOrderApi.GetWOStatusList(
        {},
        (resp: any) => {
          let deptlist: any = [];
          resp.workOrderStatusList.map((facilist: any) => {
            deptlist.push({
              label: facilist.woStatusName,
              value: facilist.woStatusID,
              data: facilist,
            });
          });
          resolve(deptlist);
        },
        (error: any) => {
          console.log("error =>", error);
          toast.error(error);
          reject([]);
        }
      );
    }).catch((error: any) => []);
    setStatusoption(statusapiresp);

    // Fetch assignment type list
    const assignmenttypeapiresp = await new Promise((resolve, reject) => {
      workOrderApi.GetWOAssignmentTypeList(
        {},
        (resp: any) => {
          let deptlist: any = [];
          resp.workOrderAssignmentTypeList.map((assignmentType: any) => {
            deptlist.push({
              label: assignmentType.woAssignmentTypeName,
              value: assignmentType.woAssignmentTypeID,
              data: assignmentType,
            });
          });
          resolve(deptlist);
        },
        (error: any) => {
          console.log("error =>", error);
          toast.error(error);
          reject([]);
        }
      );
    }).catch((error: any) => []);
    setAssigntypeoption(assignmenttypeapiresp);
  };

  const openModalWithScheduler = (data: any) => {
    setEditData(data);
    // setSelectedSchedulerID(data?.schedulerID);
    woListModelRef.current?.showModal();
  };

  useEffect(() => {
    init_page_data();
  }, []);

  // Call getSchedulerList only after filters are initialized
  useEffect(() => {
    if (filtersInitialized) {
      getSchedulerList();
    }
  }, [filters, filtersInitialized]);

  useEffect(() => {
    if (gridApi?.current) {
      // Auto size all columns based on their content
      gridApi?.current.sizeColumnsToFit();
    }
  }, [gridApi]);

  useEffect(() => {
    if (filtersInitialized) {
      getSchedulerList();
    }
    
    const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
    const hasActiveLocationFilter = filters?.hasOwnProperty("facilityIDs");
    setFiltersApplied({
      generalFilter: hasActiveFilters,
      locationFilter: hasActiveLocationFilter,
    });
  }, [currentPage, searchParam, filters]);

  return (
    <Layout>
      <Header title="Preventive Maintenance">
        <Header.Right>
          <div className="border border-primary rounded-md overflow-hidden">
            <Button
              disabled={true}
              theme={view == "calendar" ? "primary" : "light"}
              className="!rounded-none !border-0 hidden"
              onClick={() => {
                setView("calendar");
              }}
            >
              Calendar View
            </Button>
            <Button
              theme={view == "list" ? "primary" : "light"}
              className="!rounded-none !border-0 hidden"
              onClick={() => {
                setView("list");
              }}
            >
              Schedular View
            </Button>
          </div>
          <Drawer
            _ref={createDrawerRef}
            onClose={() => {
              createSchedulerRef?.current?.reset();
              setEditData(null);
              setDuplicateFrom(null);
            }}
            outsideClose={false}
            isAfterOpenRender={true}
          >
            <Drawer.Button>
              <Button disabled={!getPermissionInfo(location.pathname, "Add", loggedinuser)}>Create Schedule PM</Button>
            </Drawer.Button>
            <Drawer.Content
              title={editData ? "Edit Schedule" : duplicateFrom ? "Duplicate Schedule" : "Create New Schedule"}
              className="!w-[45rem]"
            >
              {/*!w-[39.563rem]*/}
              {!getPermissionInfo(location.pathname, "Add", loggedinuser) ? (
                <div className="p-4 text-red-500">
                  You don't have permission to access this form.
                </div>
              ) : (
                <CreateScheduler
                  _ref={createSchedulerRef}
                  editData={editData}
                  duplicateData={duplicateFrom}
                  onCreate={() => {
                    setEditData(null);
                    setDuplicateFrom(null);
                    getSchedulerList();
                    createDrawerRef?.current?.close();
                  }}
                  onCancel={() => {
                    setEditData(null);
                    setDuplicateFrom(null);
                    getSchedulerList();
                    createDrawerRef?.current?.close();
                  }}
                />
              )}
            </Drawer.Content>
          </Drawer>
        </Header.Right>
      </Header>
      {view == "list" && (
        <>
          <div className="flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]">
            <Pagination
              perPage={PAGE_SIZE}
              totalRecords={totalRecords}
              onPageChange={setCurrentPage}
              currentPage={currentPage}
            />
            <Search onSearch={setSearchParam} placeholder='Search by schedule no or priority' />
          </div>
          <div className="bg-[#FAFAFA] w-full">
            <div className="flex gap-4 px-5 py-2 items-center">
              <Button
                theme="light"
                onClick={() => filtersRef.current.showModal()}
              >
                Filter <Icon name="filter" size={1.4} className={filtersApplied.generalFilter ? "text-blue-700" : ""} />
              </Button>
              <Dropdown>
                <Dropdown.Button>
                  <Button theme="light">
                    <Icon name="grlocation" size={1.2} className={filtersApplied.locationFilter ? "text-blue-700" : ""} /> Location{" "}
                    <Icon name="arrowdown" size={1.1} />
                  </Button>
                </Dropdown.Button>
                <Dropdown.Content>
                  {facilityoption?.map((facility: any) => {
                    return (
                      <Menu
                        onClick={() => {
                          setFilters({
                            ...filters,
                            facilityIDs: [facility.value + ""],
                          });
                        }}
                      >
                        {facility.label}
                      </Menu>
                    );
                  })}
                </Dropdown.Content>
              </Dropdown>
              <p
                className="text-primary font-semibold text-sm cursor-pointer"
                onClick={() => {
                  setFilters({});
                  localStorage.removeItem('maintenanceCalendarFilters');
                }}
              >
                Clear Filters
              </p>
            </div>
            <div className="ag-theme-alpine px-4 w-full h-1/2">
              <AgGridReact
                columnDefs={columnDefs as any} // Pass columnDefs
                rowData={rowData || []} // Pass rowData
                rowSelection="multiple"
                onGridReady={onGridReady}
                pagination={false}
                domLayout="autoHeight"
                onRowClicked={onRowClicked}
                loadingOverlayComponent={Loader}
                noRowsOverlayComponent={() => (
                  <div className="flex items-center justify-center h-full">
                    <div className="text-center text-gray-500">
                      <div className="text-lg font-medium">No Data Found</div>
                    </div>
                  </div>
                )}
              />
            </div>
          </div>
          <Filters
            _ref={filtersRef}
            config={filterConfig}
            filters={filters}
            onUpdate={setFilters}
          />
        </>
      )}
      {view == "calendar" && <CalendarMP />}

      <OpenWOlistModal
        _ref={woListModelRef}
        schedulerID={editData?.schedulerID}
        onCloseCallback={() => setEditData(null)}
      />
    </Layout>
  );
};

export default MaintenanceCalendar;
